module.exports = __webpack_public_path__ + "static/media/2020-06-04 x-ray-evaluation.e2508ff9.md";